import React, { useRef, useEffect } from 'react';

const NumberKeyDown = ({ componentRef, typeFormat = 'integer', children }) => {
    const validKeys = useRef([
        'ArrowUp',
        'ArrowDown',
        'ArrowLeft',
        'ArrowRight',
        'Tab',
        'Backspace',
        'Delete',
        'End',
        'Home'
    ]);

    const validChars = useRef([]);

    useEffect(() => {
        componentRef.current.addEventListener('keydown', keyDownHandler);

        if (typeFormat === 'integer') {
            //tab backspace arrows delete end, home
            validChars.current = [8, 9, 37, 38, 39, 40, 46, 35, 36];
        } else {
            //tab backspace arrows delete decimal comma period, end, home
            validChars.current = [8, 9, 37, 38, 39, 40, 46, 110, 188, 190, 35, 36];

            validKeys.current.push(',');
            validKeys.current.push('.');
        }

        return () => componentRef?.current?.removeEventListener('keydown', keyDownHandler);
    });

    const keyDownHandler = (e) => {
        let ch = typeof e.which === 'number' ? e.which : e.keyCode;

        let allow = false;

        /*
         * Character detection using which and keyCode has been removed from the w3 specs,
         * however, the new methods, code and key, are not widely supported yet(~70% global share on 5/10/17)
         * Try to utilize the new method, but fall back to the old if not yet supported.
         * The new method will prevent the $#% being counted as number characters
         */
        if (e.key && typeof e.key === 'string') {
            allow = isNumberKey(e.key);
        } else if (!(e.key && typeof e.key === 'string') && isNumberKeyCode(ch)) {
            allow = true;
        }

        if (validChars.current.indexOf(ch) > -1) {
            allow = true;
        }

        if (!allow) {
            e.preventDefault();
            return false;
        }
    };

    const isNumberKeyCode = (ch) => {
        return !isNotANumberKeyCode(ch);
    };

    const isNumberKey = (key) => {
        return /\d/.test(key) || validKeys.current.indexOf(key) > -1; // check that key is a digit, or is in the validKeys array
    };

    const isNotANumberKeyCode = (ch) => {
        return ch < 48 || (ch > 57 && ch < 96) || ch > 105;
    };

    return <>{children}</>;
};

export default NumberKeyDown;
